<template>
    <div>
        <Header @click="logout()"></Header>
        <div class="main">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import Header from '../components/Header';

    export default {
        methods: {
            logout() {
                const that = this;
                this.$store.dispatch('session/logout').then(() => {
                    that.$router.push({ name: 'Login' });
                });
            }
        },
        components: {
            Header
        }
    }
</script>

<style lang="scss">
    .main {
        margin-top: $space-32;
        margin-left: $space-32;
        margin-right: $space-32;
    }
</style>